import PATH_PAGE from '@/router/path';
import { RouteParams } from '@/router/type';
import { useNavigate, useParams } from 'react-router-dom';
import { useDemoMode } from '@/context/DemoModeContext';

const useParamWorkspaceId = () => {
  const navigate = useNavigate();
  const { orgId, workspaceId } = useParams<RouteParams>();
  const { isDemoMode } = useDemoMode();

  if (!workspaceId) {
    // If no workspace but has org, redirect to org overview
    if (orgId) {
      const orgPath = isDemoMode
        ? `/demo/dashboard/${orgId}`
        : `/dashboard/${orgId}`;
      navigate(orgPath, {
        replace: true,
      });
      return { orgId: orgId || '', workspaceId: '' };
    }

    // No org or workspace, redirect to settings
    navigate(PATH_PAGE.setting.workspaces.root, {
      replace: true,
    });
    return { orgId: '', workspaceId: '' };
  }

  return { orgId: orgId || '', workspaceId };
};

export default useParamWorkspaceId;
